import FocusTrap from 'focus-trap-react';
import { motion } from 'framer-motion';
import { useRecoilState } from 'recoil';

import { AdvancedSearchForm } from '@/components/modules/advanced-search/form';
import { advancedSearchFormOpenState } from '@/state/search';
import { tv } from '@/utils/styles';

export interface AdvancedSearchDropdownProps {
  onSearch: () => void;
}

const AdvancedSearchDropdown = ({ onSearch }: AdvancedSearchDropdownProps) => {
  const [isOpen, setIsOpen] = useRecoilState(advancedSearchFormOpenState);

  // This event is called when ESC is pressed (which also deactivates the Trap)
  const handleOnDeactivate = () => {
    setIsOpen(false);
  };

  const { layoutGrid, overlay, wrapper } = styles();

  return (
    <FocusTrap
      focusTrapOptions={{
        onPostDeactivate: handleOnDeactivate,
        allowOutsideClick: true,
      }}
    >
      <div className={layoutGrid()}>
        <motion.div
          className={wrapper()}
          initial="hidden"
          exit="hidden"
          animate={isOpen ? 'open' : 'hidden'}
          variants={{
            open: { top: '0' },
            hidden: { top: '-20px' },
          }}
          transition={{ duration: 0.2 }}
        >
          <AdvancedSearchForm onSearch={onSearch} />
        </motion.div>
        <motion.div
          className={overlay()}
          onClick={() => setIsOpen(false)}
          initial="hidden"
          exit="hidden"
          animate={isOpen ? 'open' : 'hidden'}
          variants={{
            open: { opacity: 1 },
            hidden: { opacity: 0 },
          }}
          transition={{ duration: 0.2 }}
        />
      </div>
    </FocusTrap>
  );
};

const styles = tv({
  slots: {
    wrapper: 'relative',
    overlay: 'absolute bottom-0 left-0 right-0 top-0 z-2 bg-[rgba(0,0,0,0.2)]',
    layoutGrid:
      'absolute bottom-0 left-0 right-0 top-[calc(var(--app-search-bar-height)-1px)] sm:top-[calc(var(--app-search-bar-height-md)-1px)] md:grid md:w-full md:items-start lg:top-[calc(var(--app-search-bar-height-lg)-1px)] lg:grid-cols-[900px_1fr]',
  },
});

export { AdvancedSearchDropdown };
